import $ from "jquery";
import datepickerFactory from "jquery-datepicker";
import datepickerJAFactory from "jquery-datepicker/i18n/jquery.ui.datepicker-ja";
import holiday_jp from "@holiday-jp/holiday_jp";

datepickerFactory($);
datepickerJAFactory($);

$(function () {
  //本日の日付を初期値にする
  var today = new Date();
  const days = ["日", "月", "火", "水", "木", "金", "土"];
  today.setDate(today.getDate() + 60);
  var yyyy = today.getFullYear();
  var mm = ("0" + (today.getMonth() + 1)).slice(-2);
  var dd = ("0" + today.getDate()).slice(-2);

  if (document.getElementById("checkin_main") != null) {
    document.getElementById("checkin_main").value = yyyy + "/" + mm + "/" + dd;
  }
  if (document.getElementById("checkin_air") != null) {
    document.getElementById("checkin_air").value = yyyy + "/" + mm + "/" + dd;
  }

  //複数のdatepickerに対して設定を適用
  $(".datepicker").each(function () {
    $(this).datepicker({
      dateFormat: "yy/mm/dd",
      yearSuffix: "年",
      showMonthAfterYear: true,
      monthNames: [
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月",
      ],
      dayNames: ["日", "月", "火", "水", "木", "金", "土"],
      dayNamesMin: ["日", "月", "火", "水", "木", "金", "土"],
      minDate: "0",
      hideIfNoPrevNext: true,
      //土日・祝日に色をつける
      beforeShowDay: function (date) {
        const holiday = holiday_jp.between(date, date);
        if (holiday.length > 0) {
          // 祝日の場合
          return [true, "js-custom-holiday", ""];
        } else if (date.getDay() === 0) {
          // 日曜日の場合
          return [true, "js-custom-sunday", ""];
        } else if (date.getDay() === 6) {
          // 土曜日の場合
          return [true, "js-custom-saturday", ""];
        }
        // 平日の場合
        return [true, "js-custom-weekday", ""];
      },
      //position-fixedの要素に対しても位置がおかしくならないようにする処理
      beforeShow: function (input, instance) {
        $(input).next(".appendDatepicker").append($("#ui-datepicker-div")); //input要素の次の「appendDatepicker」にカレンダーを入れる
      },
    });
  });
});
